<div class="btn-group d-block primary-dropdown w-100" dropdown [isDisabled]="!!disabled" (isOpenChange)="onModelTouched()">
  <button class="h-100 w-100 d-flex primary-dropdown-toggle border-radius-sm kh-medium-text grey-accessible bg-grey-medium-light" dropdownToggle type="button" aria-controls="dropdown-menu" [class.selected]="!!selectedItem" role="button" [attr.data-testId]="testId+'-button'">
    <span class="kh-medium-text d-block mr-xs text-truncate kh-grey-accessible">{{resolveName(selectedItem)}}</span>
    <kh-img class="d-block primary-dropdown-arrow" path="icon-dropdown.svg"></kh-img>
  </button>
  <ul class="dropdown-menu primary-dropdown-list border-radius-sm mt-xs" *dropdownMenu id="dropdown-menu" role="menu" aria-labelledby="button-animated" [attr.data-testid]="testId">
    <li *ngFor="let item of items" role="button" class="primary-dropdown-item medium-title-text black p-xxs m-xs border-radius-sm" (click)="onItemClick(item)" [attr.data-testid]="testId+'-'+resolveName(item)">
      {{resolveName(item)}}
    </li>
  </ul>
</div>

<div *ngIf="isInvalid()" class="mt-kh-1 pl-kh-2">
  <div *ngFor="let error of getErrorMessages(control.errors)" class="kh-red kh-small-text">
    {{error}}
  </div>
</div>
